import { render, staticRenderFns } from "./zixunlist.vue?vue&type=template&id=678d57fe&scoped=true&"
import script from "./zixunlist.vue?vue&type=script&lang=js&"
export * from "./zixunlist.vue?vue&type=script&lang=js&"
import style0 from "./zixunlist.vue?vue&type=style&index=0&id=678d57fe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d57fe",
  null
  
)

export default component.exports